import React, { useState } from 'react'
import { Container, Row, Col, Accordion, ListGroup, Carousel, Pagination} from 'react-bootstrap';
import { Link } from 'react-router-dom'
import { host as host_api } from '../axiosInterceptor'

const host = process.env.REACT_APP_URL_APP;

export const loader = () => {

    // if(localStorage.getItem("TOKEN") === null){
        
    //     console.log("redirecting to login");
    //     return redirect("/login");
    
    // }
    return null;
};

function Home() {

  const [current_pag,set_current_pag] = useState(1);

  return (
    <Container fluid>

      <Row className='justify-content-center'>
        <Col xs="10" sm="4" md="3" lg="3" xl="3" className='p-0 ps-1'>
          <Accordion defaultActiveKey="0" className='mt-4'>

            <Accordion.Item eventKey="0">
              <Accordion.Header>Nuestros Servicios</Accordion.Header>
              <Accordion.Body className='p-0'>
                <ListGroup className='rounded-0'>
                  <ListGroup.Item className='hover-item p-0'>
                    <Link to={'/search_of_resolved_judgments'} className='d-table p-2 pt-3 pb-3 link-secondary link-underline-opacity-0 text-center w-100'>Buscador Juridico Documental</Link>
                  </ListGroup.Item>
                  <ListGroup.Item className='hover-item p-0'>
                    <Link to={'/history_of_resolved_judgments'} className='d-table p-2 pt-3 pb-3 link-secondary link-underline-opacity-0 text-center w-100'>Sentencias Historicas</Link>
                  </ListGroup.Item>
                  <ListGroup.Item className='hover-item p-0'>
                    <Link to={'/digital_publications/Boletines-Judiciales/1'} className='d-table p-2 pt-3 pb-3 link-secondary link-underline-opacity-0 text-center w-100'>Publicaciones Digitales</Link>
                  </ListGroup.Item>
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>Acerca de Nosotros</Accordion.Header>
              <Accordion.Body className='p-0'>
                <ListGroup className='rounded-0'>
                  <ListGroup.Item className='hover-item p-0'>
                    <Link to={'/mission'} className='d-table p-2 pt-3 pb-3 link-secondary link-underline-opacity-0 text-center w-100'>Misión, Visión, Objectivos y Politicas</Link>
                  </ListGroup.Item>
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>Marco Legal</Accordion.Header>
              <Accordion.Body className='p-0'>
                <ListGroup className='rounded-0'>
                  <ListGroup.Item className='hover-item p-0'>
                    <Link to={`${host_api}/assets/documents/agreement/AcuerdoNo305.pdf`} target='_blank' className='d-table p-2 pt-3 pb-3 link-secondary link-underline-opacity-0 text-center w-100'>
                      <p className='m-1 text-center'>

                        <img src={`${host}/icopdf.png`} className='me-1' style={{width:"20px"}} alt="" />  
                        Acuerdo No. 305 - 2015

                      </p>
                    </Link>
                  </ListGroup.Item>

                  <ListGroup.Item className='hover-item p-0'>
                    <Link to={`${host_api}/assets/documents/agreement/AcuerdoNo.033-2003.pdf`} target='_blank' className='d-table p-2 pt-3 pb-3 link-secondary link-underline-opacity-0 text-center w-100'>
                      
                      <p className='m-1 text-center'>
                        
                        <img src={`${host}/icopdf.png`} className='me-1' style={{width:"20px"}} alt="" />
                        Acuerdo No. 33 - 2003
                      
                      </p>
                    </Link>
                  </ListGroup.Item>

                  <ListGroup.Item className='hover-item p-0'>
                    <Link to={`${host_api}/assets/documents/agreement/AcuerdoNo306.pdf`} target='_blank' className='d-table p-2 pt-3 pb-3 link-secondary link-underline-opacity-0 text-center w-100'>
                      
                      <p className='m-1 text-center'>
                        <img src={`${host}/icopdf.png`} className='me-1' style={{width:"20px"}} alt="" />
                        Acuerdo No. 306 - 2015
                      </p>
                    </Link>
                  </ListGroup.Item>
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>Contáctanos</Accordion.Header>
              <Accordion.Body className='p-0'>
                <ListGroup className='rounded-0'>
                  <ListGroup.Item style={{fontSize:"14px"}} className='hover-item link-secondary link-underline-opacity-0'>info.cedij@poderjudicial.gob.ni</ListGroup.Item>
                  <ListGroup.Item className='hover-item link-secondary link-underline-opacity-0'>Teléfono: (505) 22330575</ListGroup.Item>
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
        <Col xs="10" sm="8" md="9" lg="9" xl="9">
          <p className='mt-4 pt-4 lh-base mb-4' style={{textAlign:"justify"}}>
            El CEDIJ, es un órgano técnico del Poder Judicial de la República de Nicaragua que se encarga de 
            gestionar el conocimiento en el ámbito jurídico, jurisprudencial, doctrinal y legislativo, en conformidad 
            con el ordenamiento jurídico, los procesos documentales, la calidad en la prestación de los servicios y 
            la nueva tecnologías, poniendo a disposición el acervo jurídico enriquecido a funcionarios judiciales y 
            usurios en general para facilitar el acceso a la información especializada.
          </p>

          <Carousel>
            <Carousel.Item>
              <img src={`${host}/1.jpg`} style={{height:"395px"}} alt="" />
            </Carousel.Item>
            <Carousel.Item>
              <img src={`${host}/2.jpg`} alt="" />
            </Carousel.Item>
            <Carousel.Item>
              <img src={`${host}/3.jpg`} alt="" />
            </Carousel.Item>
          </Carousel>

        </Col>
        {/* <Col xs="10" sm="11" md="11" lg="2" xl="2">
          <p className='m-1 mt-4 fw-bold border-dark-subtle border-bottom text-center'>
            Sentencias Relevantes
          </p>

          <div id='pag_1' hidden={current_pag !== 1}>

            <h6>2018 - Sentencias de Familia Alimentos ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Confirma la igualdad de derechos de los hijos ante la ley(articulo 75). En virtud de ellos exhorta
              a las autoridades judiciales a tasar los alimentos de forma equitativa sin descriminacion o ...
            </p>

            <h6>2019 - Sentencias de Familia con enfoque de género ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Relevancia de la sentencia emitida por la Corte Suprema de Justicia, Sala de lo Civil: Establecer 
              que las múltiples funciones domésticas que realiza dentro del hogar una ama de casa en ...
            </p>

            <h6>2019 - Seguridad social. Profesores horario ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Relevancia de la sentencia de seguridad social emitida por la Corte Suprema de Justicia, Sala
              Constitucional: Los efectos erga omnes ara las autoridades universitarias que contratan a docentes ...
            </p>

            <h6>2019 - Alimentos ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Relevancia de la sentencia de Familia emitida por la Corte Suprema de Justicia, Sala de lo Civil:
              Confirma la igualdad de derechos de los hijos ante la ley (artículo 75) en virtud de ello ...
            </p>
          </div>

          <div id='pag_2' hidden={current_pag !== 2}>
            <h6>2019 - Beneficios sociales. Reposo ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Relevancia de la sentencia Laboral emitida por la Corte Suprema de Justicia, Sala Constitucional:
              Confirmatoria de la ley al ratificar la prohibición de descontar los tres días de reposo por ...
            </p>

            <h6>2019 - Despido: Estado de embarazo ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Relevancia de la sentencia Laboral emitida por el Tribunal Laboral de Apelación: Confirma el orden
              constitucional de la protección especial a la mujer trabajadora en estado de embarazo ...
            </p>

            <h6>2019 - Divorcio: Distribución de bienes ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Relevancia de la sentenci de Familia emitida por la Corte Suprema de Justicia, la Sala de lo Civil 
              y de Familia por Ministerio de Ley del año 2016: Priva el derecho básico de los menores a ...
            </p>

            <h6>2020 - Alevosía ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Relevancia de la sentencia: Confirmatoria de la resolución de primera instancia al comprobarse que
              no se configuró el delito de asesinato, por cuanto la motivación de la pena debe estar ...
            </p>

          </div>

          <div id='pag_3' hidden={current_pag !== 3}>

            <h6>2020 - Principio de proporcionalidad de la pena ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Relevancia de la sentencia emitida por la Sala de lo Penal de la Corte Suprema de Justicia: La 
              protección de los derechos del procesado al dictar una pena de acuerdo a los delitos probados...
            </p>

            <h6>2020 - Consumo. No se le comprobó al acusado la finalidad de la droga que tenía en posesión, no configur...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              "..para que se configure la conducta delictiva que se le endilga al encartado, no sólo debe establecerse
              el hecho objetivo del hallazgo de la droga decomisada, sino que además se requiere la ...
            </p>

            <h6>2020 - segunda instancia no ponía término al proceso, ya que no resolvió el confl...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              1) "..aquellas resoluciones bajo el formato de sentencias que declaran la nulidad parcial o total de un
              proceso, no son sentencias en strictu sensu, sino más bien autos, por lo que el anális...
            </p>

            <h6>2020 - Jornada extraordinaria ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              El derecho que tienen los trabajadores a que les pague las horas extras trabajadas o el tiempo de 
              trabajo laborado fuera de la jornada ordinaria ...
            </p>

          </div>

          <div id='pag_4' hidden={current_pag !== 4}>

            <h6>2020 - Responsabilidad probatoria ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              El reconocimiento del pago de vacaciones no descansadas al demandante, al momento de pagar la liquidación
              final el empleador, de acuerdo a lo que en derecho corresponde según las pruebas ...
            </p>

            <h6>2020 - Multa ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              "... como ya lo ha hecho en otras sentencias esta Sala, hacer propios, una vez más, los conceptos vertidos
              por la Honorable Sala de lo Constitucional de este Supremo Tribunal en Sentencia d...
            </p>

            <h6>2020 - Silencio administrativo negtivo ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              "... el ACUERDO MINISTERIAL No. JCHG-019-12-08, RELATIVO AL PROCEDIMIENTO ADMINISTRATIVO LABORAL ORAL, señala
              en el artículo 58 que transcurridos los cinco días hábiles señalados anteriormente...
            </p>

            <h6>2021 - Concurso de Delitos ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Relevancia de la sentencia emitida por la Sala de lo Penal de la Corte Suprema de Justicia: El fallo
              impugnado estimó una atenuante por analogía, relacionada con la buena conducta anterior...
            </p>

          </div>

          <div id='pag_5' hidden={current_pag !== 5}>

            <h6>2021 - Fuero Materno ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Embarazo y prescripción "... la parte actora estaba en la obligación legal de demostrar en este caso los
              extremos de la demanda y la subsanación de la misma al tenor del arto. 54...
            </p>

            <h6>2021 - Audiencia de debate de pena ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Relevancia de la sentencia emitida por la Sala de lo Penal de la Corte Suprema de Justicia: Lo resuelto en 
              primera instancia no se trata de una sentencia, sino de un auto motivado relativo...
            </p>

            <h6>2021 - Horas Extras ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Sentencia Laboral Demostración de trabajo extraordinrio "... todos los trabajadores en general, tienen un
              limite máximo de jornada de trabajo efectiva de ocho horas diarias, entendiendose...
            </p>

            <h6>2021 - Juicio ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Relevancia de la sentencia emitida por la Sala de lo Penal de la Corte Suprema de Justicia: La suspensión
              del juicio, no opera en situaciones de hechos no previstas en el art. 288CPP ...
            </p>
           

          </div>

          <div id='pag_6' hidden={current_pag !== 6}>

            <h6>2021 - Calificación Jurídica del Hecho ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              Relevancia de la sentencia emitida por la Sala de lo Penal de la Corte Suprema de Justicia: El juez
              tiene la potestad de dar al hecho una calificación jurídica distinta y aplicar la pena corr...
            </p>

            <h6>2021 - Médico Forense ...</h6>
            <p style={{fontSize:"13px", textAlign:"justify"}}>
              La protección de los derechos de las víctimas frente a los agresores en los delitos sexuales, que pretenden
              que el delito quede impune a causa de una aparente falta de capacidad legal de la...
            </p>


          </div>

          <p className='text-center' style={{fontSize:"12px"}}>{`Página ${current_pag} de 6`}</p>
          <div className='d-table ms-auto me-auto'>

            <Pagination>
              <Pagination.First onClick={()=> set_current_pag(1)} disabled={current_pag === 1}/>
              <Pagination.Prev onClick={()=> set_current_pag(current_pag - 1)} disabled={current_pag === 1}/>

              <Pagination.Next onClick={()=> set_current_pag(current_pag + 1)} disabled={current_pag === 6} />
              <Pagination.Last onClick={()=> set_current_pag(6)} disabled={current_pag === 6}/>
            </Pagination>

          </div>
          
        </Col> */}
      </Row>
    </Container>
  )
}

export default Home